import { useSelector } from "react-redux";

/**
 * GlobalHeader と、そこから開くポップオーバー / パネル（AccountPopover・soremon）
 * の位置と開き方を揃えるための共通値。
 */

/** GlobalHeader の高さ（px）。 */
export const GLOBAL_HEADER_HEIGHT = 64;

/** GlobalHeader の表示 / 非表示の切り替えにかかる時間（ヘッダーに追従する要素も同じ速さで動かす）。 */
export const GLOBAL_HEADER_TRANSITION = "0.15s linear";

/** ヘッダーから開くポップオーバー / パネルと、画面の下端との余白（px）。 */
export const OVERLAY_BOTTOM_MARGIN = 8;

/** ヘッダーのアイコンにホバーしてから、ポップオーバー / パネルを開くまでの時間（ms）。 */
export const OVERLAY_HOVER_OPEN_DELAY_MS = 200;

/**
 * GlobalHeader が今占めている高さ（表示中は 64、下スクロールで隠れているときは 0）。
 *
 * ヘッダーから開くポップオーバー / パネルを、ヘッダーが見えていればその真下
 * （プロジェクトバナーの上端と同じ高さ）に、隠れていれば画面の一番上に置くために使う。
 */
export const useGlobalHeaderOffset = (): number => {
  const scrollState = useSelector((state: { layout: string }) => state.layout);
  return scrollState === "down" ? 0 : GLOBAL_HEADER_HEIGHT;
};
